var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavorit = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.386 5h.23a4.529 4.529 0 0 1 3.277 1.542c1.548 1.757 1.45 4.493-.155 6.287l-.15.16-5.409 5.525c-.6.614-1.571.646-2.21.097l-.104-.097-5.547-5.667a4.637 4.637 0 0 1-1.316-3.365 4.63 4.63 0 0 1 1.492-3.29c1.747-1.607 4.496-1.504 6.276.162l.154.151.098.1.237-.242a4.531 4.531 0 0 1 2.684-1.33l.218-.022.225-.011Zm.17 2.121a2.334 2.334 0 0 0-1.619.598l-.119.114-1.016 1.038a1.096 1.096 0 0 1-1.471.081l-.089-.08-.877-.898c-.962-.982-2.472-1.08-3.394-.233a2.527 2.527 0 0 0-.808 1.796c-.017.633.2 1.246.6 1.716l.114.125 5.145 5.255 5.006-5.114c.9-.918 1.064-2.356.423-3.335l-.092-.13-.103-.125a2.351 2.351 0 0 0-1.7-.808Z",
  fill: "#231F20",
  fillRule: "nonzero"
})));
export default SvgFavorit;